type BlogCardMediaProps = {
  image: string | null;
  alt: string;
  category: string;
  priority?: boolean;
};

const BlogCardMedia = ({ image, alt, category, priority = false }: BlogCardMediaProps) => (
  <div className="aspect-[16/10] rounded-2xl bg-secondary/50 mb-5 overflow-hidden relative">
    {image ? (
      <img
        src={image}
        alt={alt}
        width={1280}
        height={800}
        loading={priority ? 'eager' : 'lazy'}
        decoding="async"
        className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
      />
    ) : (
      <>
        <div className="absolute inset-0 bg-gradient-to-br from-foreground/[0.03] to-transparent group-hover:from-foreground/[0.06] transition-all duration-500" />
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="flex items-center gap-3 opacity-80">
            <span className="w-2.5 h-2.5 shrink-0 bg-foreground rounded-full" />
            <span className="flex flex-col leading-none text-left">
              <span className="font-display text-lg font-semibold tracking-tight text-foreground">figtures</span>
              <span className="font-body text-[7px] tracking-[0.3em] text-muted-foreground uppercase">product studio</span>
            </span>
            <span className="font-body text-[10px] tracking-[0.2em] text-muted-foreground uppercase">blog</span>
          </span>
        </div>
      </>
    )}
    <div className="absolute top-4 right-4 w-8 h-8 rounded-full bg-background flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
      <span className="text-foreground text-xs">→</span>
    </div>
    <div className="absolute bottom-4 left-4">
      <span className="font-body text-[10px] tracking-[0.2em] text-muted-foreground uppercase bg-background/80 backdrop-blur-sm px-3 py-1 rounded-full">
        {category}
      </span>
    </div>
  </div>
);

export default BlogCardMedia;
